import { render, staticRenderFns } from "./GatDynaField.vue?vue&type=template&id=23fee126&scoped=true&"
import script from "./GatDynaField.vue?vue&type=script&lang=js&"
export * from "./GatDynaField.vue?vue&type=script&lang=js&"
import style0 from "./GatDynaField.vue?vue&type=style&index=0&id=23fee126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fee126",
  null
  
)

export default component.exports